module.exports = __webpack_public_path__ + "img/newIndex.06cc52b5.png";